export enum OrganizationNameType {
	RETURN_NAME = 1,
	DO_NOT_RETURN_NAME = 0,
}
